/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{Milliseconds as t}from"../../../../core/time.js";class e{constructor(){this.enabled=!0,this._time=t(0)}get time(){return this._time}advance({deltaTime:e,fixedTime:i}){return null!=i?this._time!==i&&(this._time=i,!0):(this._time=t(this._time+e),0!==e)}}class i{constructor(t,e){this.deltaTime=t,this.fixedTime=e}}export{e as AnimationTimer,i as Parameters};
